import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "card-header border-0 pt-5" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "Sản lượng"),
    /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-bold fs-7" }, "6 tháng gần nhất")
  ])
], -1)
const _hoisted_2 = { class: "card-body py-3" }
const _hoisted_3 = { class: "table-responsive" }
const _hoisted_4 = { class: "tbl" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("sup", null, [
  /*#__PURE__*/_createTextVNode(" m"),
  /*#__PURE__*/_createElementVNode("sup", null, "3")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("sup", null, " đ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("sup", null, " đ", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("sup", null, " đ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.widgetClasses, "card"])
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_table, {
            data: _ctx.data,
            size: "large",
            fit: "",
            "header-row-class-name": "thead-light",
            stripe: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "cThang",
                label: "Tháng",
                width: "100"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("span", null, _toDisplayString(scope.row.cThang.substr(3)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "nSanLuong",
                label: "Sản lượng"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("span", null, [
                    _createTextVNode(_toDisplayString(_ctx.handleNumber(scope.row.nSanLuong)), 1),
                    _hoisted_5
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "nThanhTien",
                label: "Thành tiền"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("span", null, [
                    _createTextVNode(_toDisplayString(_ctx.handleNumber(scope.row.nThanhTien)), 1),
                    _hoisted_6
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "nVat",
                label: "Phí VAT"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("span", null, [
                    _createTextVNode(_toDisplayString(_ctx.handleNumber(scope.row.nVat)), 1),
                    _hoisted_7
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "nTongTien",
                label: "Tổng tiền"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("span", null, [
                    _createTextVNode(_toDisplayString(_ctx.handleNumber(scope.row.nTongTien)), 1),
                    _hoisted_8
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"])
        ])
      ])
    ])
  ], 2))
}